import config from "config";

import { BaseService } from "services/base-service";

import { API_ROUTES } from "constants/routes";

class SupplierPhoneCallsService extends BaseService {
  constructor(url, api) {
    super(url, api);
    this.getPhoneCalls = this.getPhoneCalls.bind(this);
    this.getPhoneCall = this.getPhoneCall.bind(this);
    this.getPresignedUrl = this.getPresignedUrl.bind(this);
  }

  async getPhoneCalls(params) {
    try {
      const response = await this.agent.get("", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async getPhoneCall(id) {
    try {
      const response = await this.agent.get(`/${id}`, {
        params: {
          include: "recording,support_agent,transcript,transcript.observations",
        },
      });

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async getPresignedUrl(id) {
    try {
      const response = await this.agent.get(
        `${config.api}/supplier/presigned-urls`,
        { params: { file_id: id } }
      );

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new SupplierPhoneCallsService(
  API_ROUTES.supplierPhoneCalls
);

export default ServiceInstance;
export { ServiceInstance as SupplierPhoneCallsService };
